import React, { FC } from 'react'
import IsoListContainer from 'containers/ISO/ISOList'

const ISOListPage: FC = () => <IsoListContainer />

export default ISOListPage
